import { observable } from "mobx";
import LanguageCode from "./languageCode";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SystemComponentOutageLocalizationRequest {
  @observable
  languageCode!: LanguageCode;

  @observable
  description!: string;
}
